import React from "react";
import { Link } from "react-router-dom";
import styles from "./HomePage.module.css";
import logo from "../../assets/Full Logo_Horizontal.png";

export default function HomePage() {
  localStorage.setItem("navbar_state", "userlogin");

  const go = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className={styles.page}>
      <header className={styles.hero}>
        <div className={styles.topbar}>
          <div className={styles.brand}>
            <div className={styles.brandBadge}>
              <img src={logo} alt="P4Power" className={styles.logo} />
            </div>
          </div>

          <div className={styles.topRight}>
            <nav className={styles.navLinks}>
              <button className={styles.linkBtn} onClick={() => go("pricing")}>
                Pricing
              </button>
              <button className={styles.linkBtn} onClick={() => go("why")}>
                Benefits
              </button>
              <button className={styles.linkBtn} onClick={() => go("how")}>
                How it works
              </button>
              <button className={styles.linkBtn} onClick={() => go("contact")}>
                Contact
              </button>
            </nav>

            <div className={styles.topActions}>
              <Link
                className={styles.navBtnGhost}
                to="https://simplix.co.za/#/login"
                rel="noopener noreferrer"
              >
                Login
              </Link>
              <button className={styles.navBtn} onClick={() => go("contact")}>
                Contact Support
              </button>
            </div>
          </div>
        </div>

        <div className={styles.heroInner}>
          <div className={styles.heroCopy}>
            <span className={styles.kicker}>Prepaid Utility Solutions</span>

            <h1 className={styles.h1}>Simplify your utilities</h1>

            <p className={styles.sub}>
              Smart prepaid metering for electricity with seamless vending,
              remote control, AMI visibility, and modern utility management
              built for complexes and communities.
            </p>

            <div className={styles.ctaRow}>
              <Link
                className={styles.primaryBtn}
                to="https://simplix.co.za/#/register"
              >
                Get Started
              </Link>
              <button className={styles.secondaryBtn} onClick={() => go("how")}>
                How it works
              </button>
            </div>
          </div>

          <aside className={styles.heroPanel}>
            <div className={styles.panelTop}>
              <h2 className={styles.panelHeading}>Full control</h2>
              <p className={styles.panelSub}>
                Manage prepaid utilities with clear pricing, reliable vending,
                smart infrastructure, and better operational visibility.
              </p>
            </div>

            <div className={styles.stats}>
              <div className={styles.stat}>
                <span className={styles.kpi}>From 12%</span>
                <small>Vending fee</small>
              </div>
              <div className={styles.stat}>
                <span className={styles.kpi}>R30</span>
                <small>Ami per meter / mo</small>
              </div>
              <div className={styles.stat}>
                <span className={styles.kpi}>R10k</span>
                <small>Dcu once-off</small>
              </div>
            </div>
          </aside>
        </div>
      </header>

      <section id="why" className={styles.section}>
        <div className={styles.sectionHeader}>
          <p className={styles.sectionEyebrow}>Why P4Power</p>
          <h2 className={styles.h2}>Take control of your utilities</h2>
        </div>

        <div className={styles.cards}>
          <article className={styles.card}>
            <div className={styles.cardNumber}>01</div>
            <h3>Reliable vending</h3>
            <p>
              Fast, seamless prepaid electricity vending built for complexes,
              communities, and modern utility administration.
            </p>
          </article>

          <article className={styles.card}>
            <div className={styles.cardNumber}>02</div>
            <h3>Smart &amp; secure</h3>
            <p>
              Split smart meters reduce tampering while remote readings,
              switching, and utility controls improve management.
            </p>
          </article>

          <article className={styles.card}>
            <div className={styles.cardNumber}>03</div>
            <h3>Future-proof</h3>
            <p>
              Supports AMI data and modern billing structures so your utility
              setup is ready for more accurate tariffs and reporting.
            </p>
          </article>
        </div>

        <p className={styles.micro}>
          Free smart-meter upgrade on qualifying complexes; meters transfer to
          the body corporate after 5 years.
        </p>
      </section>

      <div className={styles.sectionDarkWrap}>
        <section id="pricing" className={styles.sectionDark}>
          <div className={styles.sectionHeader}>
            <p className={styles.sectionEyebrow}>Pricing</p>
            <h2 className={styles.h2}>Transparent pricing</h2>
          </div>

          <div className={styles.pricingGrid}>
            <div className={styles.priceCard}>
              <h3 className={styles.cardLabel}>Smart electricity meters</h3>
              <ul>
                <li>
                  Meter only: <strong>From R2,500</strong>
                </li>
                <li>Pay-off options (24 / 36 / 60 months)</li>
                <li>Rental options available</li>
              </ul>
            </div>

            <div className={`${styles.priceCard} ${styles.featured}`}>
              <span className={styles.cardLabel}>Platform</span>
              <h3>Platform &amp; admin</h3>
              <ul>
                <li>
                  Vending facilitation: <strong>From 12%</strong>
                </li>
                <li>
                  AMI: <strong>R30 / meter / month</strong>
                </li>
                <li>DCU once-off per utility</li>
              </ul>
            </div>
          </div>

          <p className={styles.micro}>
            Monies for prepaid sales are paid directly to the property council
            account; we manage prepaid areas only.
          </p>
        </section>
      </div>

      <section id="how" className={styles.sectionAlt}>
        <div className={styles.sectionHeader}>
          <p className={styles.sectionEyebrow}>How it works</p>
          <h2 className={styles.h2}>Simple process. Better control.</h2>
        </div>

        <ol className={styles.steps}>
          <li>
            <span className={styles.stepNo}>Step 01</span>
            <strong>Assess</strong>
            <span>
              We scope your complex, confirm meter counts, communication paths,
              and utility requirements.
            </span>
          </li>

          <li>
            <span className={styles.stepNo}>Step 02</span>
            <strong>Install</strong>
            <span>
              Split smart meters and DCU infrastructure are installed, with AMI
              enabled where needed.
            </span>
          </li>

          <li>
            <span className={styles.stepNo}>Step 03</span>
            <strong>Vend</strong>
            <span>
              Residents buy prepaid tokens while funds settle directly to the
              relevant council account.
            </span>
          </li>

          <li>
            <span className={styles.stepNo}>Step 04</span>
            <strong>Manage</strong>
            <span>
              Use remote reads, disconnections, exception handling, and better
              operational visibility.
            </span>
          </li>
        </ol>
      </section>

      <section id="contact" className={styles.section}>
        <div className={styles.sectionHeader}>
          <p className={styles.sectionEyebrow}>Contact &amp; support</p>
          <h2 className={styles.h2}>Talk to us</h2>
        </div>

        <div className={styles.contactWrap}>
          <div className={styles.contactCard}>
            <h3>Support channels</h3>

            <p className={styles.smallPrint}>
              At our core, we prioritise fast, reliable, and consistent
              communication. To ensure every client receives the support they
              deserve, the following service standards are in place.
            </p>

            <hr className={styles.divider} />

            <p>
              <strong>WhatsApp Support (Mon–Fri):</strong> 16:30 – 22:00
            </p>
            <p>
              <strong>WhatsApp Support (Sat &amp; Sun):</strong> 09:00 – 21:00
            </p>

            <div className={styles.noteBox}>
              <p className={styles.noteTitle}>Weekend support guidelines</p>
              <ul className={styles.noteList}>
                <li>
                  Responses may be delayed depending on volume and availability.
                </li>
              </ul>
            </div>

            <hr className={styles.divider} />

            <p>
              <strong>Phone (Mon–Fri):</strong> 07:30 – 16:30
            </p>
            <p>
              <strong>Call:</strong> 060&nbsp;895&nbsp;4946
            </p>
            <p>
              <strong>Email:</strong>{" "}
              <a href="mailto:info@p4power.co.za">info@p4power.co.za</a>
            </p>
          </div>

          <div className={styles.contactCard}>
            <h3>Office</h3>
            <p>121 Soutpansberg Drive, Van Riebeeck Park, Kempton Park 1621</p>
            <p>Birchleigh, PO Box 7715</p>
          </div>

          <div className={styles.contactCard}>
            <h3>Quick links</h3>
            <div className={styles.linkRow}>
              <Link
                className={styles.inlineBtn}
                to="https://simplix.co.za/#/login"
              >
                Login
              </Link>
              <Link
                className={styles.primaryBtn}
                to="https://simplix.co.za/#/register"
              >
                Create account
              </Link>
            </div>
          </div>
        </div>
      </section>

      <div className={styles.footerWrap}>
        <footer className={styles.footer}>
          <div>
            © {new Date().getFullYear()} P4Power • REG NO 2016 / 354805 / 07
          </div>

          <div>
            121 Soutpansberg Drive, Van Riebeeck Park, Kempton Park 1621
          </div>

          <div className={styles.footerLinks}>
            <button className={styles.linkBtn} onClick={() => go("pricing")}>
              Pricing
            </button>
            <button className={styles.linkBtn} onClick={() => go("why")}>
              Benefits
            </button>
            <button className={styles.linkBtn} onClick={() => go("how")}>
              How it works
            </button>
            <button className={styles.linkBtn} onClick={() => go("contact")}>
              Contact
            </button>
            <a
              className={styles.termsDownloadLink}
              href="/legal/p4power-consumer-portal-eula-and-service-terms.pdf"
              download="P4Power-Terms-and-Conditions.pdf"
              rel="noopener noreferrer"
            >
              Download EULA
            </a>
          </div>
        </footer>
      </div>
    </div>
  );
}
